module.exports = __webpack_public_path__ + "media/images/app-store@2x-2f12f98bf79cf5bf35f519d6fd2f4a9c.webp";